module.exports = __webpack_public_path__ + "assets/images/users-group.svg?fffc4a373ec06bf3b3bb88ce23866c06";


//////////////////
// WEBPACK FOOTER
// ./_source/images/icons/sessions/users-group.svg
// module id = 628
// module chunks = 0